import { LockOutlined } from "@mui/icons-material";
import SecurityUpdateIcon from '@mui/icons-material/SecurityUpdate';
import { VerifiedUser } from "@mui/icons-material";
import { FileDownload } from "@mui/icons-material";
import HeroSection from "../../components/HeroSection";
import { PersonPin } from "@mui/icons-material";
import { SupportAgent } from "@mui/icons-material";
import { Shield } from "@mui/icons-material";
import GetStartedFreeTrial from "../../components/GetStartedFreeTrial";
import { Helmet } from "react-helmet-async";

const securityContent = [
    {
        icon: <LockOutlined style={{ color: '#181842', fontSize: '3.5rem', width: '50%', margin: 'auto' }} />,
        title: "Advanced Data Encryption",
        description:
            "RD Rental uses industry-standard encryption to protect all data both in transit and at rest. This ensures that your vehicle rental business data, customer information, and operational records remain secure and confidential."
    },
    {
        icon: <VerifiedUser style={{ color: '#181842', fontSize: '3.5rem', width: '50%', margin: 'auto' }} />,
        title: "Multi-Factor Authentication (MFA)",
        description:
            "Strengthen account security with multi-factor authentication. RD Rental adds an extra layer of protection beyond passwords, significantly reducing the risk of unauthorized access to your rental management system."
    },
    {
        icon: <SecurityUpdateIcon style={{ color: '#181842', fontSize: '3.5rem', width: '50%', margin: 'auto' }} />,
        title: "Continuous Security Updates",
        description:
            "Our security team continuously monitors threats and deploys regular updates to address vulnerabilities. This proactive approach ensures RD Rental stays protected against evolving cyber risks."
    },
    {
        icon: <PersonPin style={{ color: '#181842', fontSize: '3.5rem', width: '50%', margin: 'auto' }} />,
        title: "Role-Based Access Control (RBAC)",
        description:
            "Control who can access specific features and data within RD Rental. Role-based access ensures sensitive rental, customer, and financial information is only available to authorized users."
    },
    {
        icon: <Shield style={{ color: '#181842', fontSize: '3.5rem', width: '50%', margin: 'auto' }} />,
        title: "Regular Security Audits & Monitoring",
        description:
            "RD Rental undergoes regular security audits and system monitoring to identify potential risks early. This helps maintain a secure and reliable platform for your rental operations."
    },
    {
        icon: <SupportAgent style={{ color: '#181842', fontSize: '3.5rem', width: '50%', margin: 'auto' }} />,
        title: "Incident Response & Business Continuity",
        description:
            "In the event of a security incident, our response team acts quickly to mitigate risks, restore system integrity, and ensure minimal disruption to your rental business operations."
    },
];


const Security = () => {
    return (
        <div>
            <Helmet>
                <title>Security & Data Protection | RD Rental</title>
                <meta
                    name="description"
                    content="Learn how RD Rental ensures data security, privacy, and reliability for vehicle rental management software using industry-standard security practices."
                />
            </Helmet>
            <HeroSection
                mainHeading="Security & Data Protection at RD Rental"
                backgroundImage="../images/security-rd-rental.png"
            />

            <section style={{ paddingTop: "3.5rem", paddingBottom: "2rem" }}>
                <div style={{ maxWidth: "1200px", margin: "auto" }}>
                    <h1 style={{ fontSize: "2rem", fontWeight: "bold", marginBottom: "1rem", textAlign: "center" }}>
                        Enterprise-Grade Security for Vehicle Rental Management Software
                    </h1>

                    <p style={{ textAlign: "center", maxWidth: "900px", margin: "0 auto" }}>
                        RD Rental is built with security, privacy, and reliability at its core.
                        Our vehicle rental management software follows industry-standard security
                        practices to protect your business data, customer information, and fleet records.
                    </p>
                </div>
            </section>

            <section style={{ paddingTop: '3.5rem', paddingBottom: '3.5rem' }}>
                <div style={{ maxWidth: '1200px', margin: 'auto', marginTop: '2rem' }}>
                    {securityContent.map((item, index) => (
                        <div key={index} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '2rem' }}>
                            <div style={{ textAlign: 'center', width: '25%' }}>
                                {item.icon}
                            </div>
                            <div style={{ width: '75%', paddingLeft: '2rem', paddingRight: '2rem', marginTop: '1rem' }}>
                                <h2 style={{ color: '#181842', fontSize: '1.25rem', marginBottom: '1rem', fontWeight: 'bold' }}>
                                    {item.title}
                                </h2>
                                <p style={{ textAlign: 'justify' }}>
                                    {item.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            <section style={{ paddingTop: '2rem', paddingBottom: '2rem', position: 'relative', backgroundColor: 'white' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                    <div style={{
                        maxWidth: '600px',
                        margin: 'auto',
                        backgroundColor: 'white',
                        padding: '1rem',
                        textAlign: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center'
                    }}>
                        <FileDownload
                            style={{ color: '#1D4ED8', fontSize: '3.5rem', marginBottom: '1rem' }}
                        />
                        <h2 style={{ fontSize: "1.5rem", fontWeight: "bold", marginBottom: "0.75rem" }}>
                            Security Documentation & Compliance
                        </h2>
                        <p>
                            Review RD Rental’s security documentation to understand how we protect your data.
                            Share this information with your team or compliance partners.
                            If you have any questions, our support team is always available to help.
                            We want you to feel confident using RD Rental for rental operations,
                            collaboration, and data storage.
                        </p>
                    </div>
                </div>
            </section>

            <GetStartedFreeTrial />
        </div>
    )
}

export default Security;